import React from "react";
import moment from "moment";
import { Table } from "antd";

const { Column } = Table;

const TopAnchorsTable = ({ dataSource }) => {
  return (
    <Table dataSource={dataSource} pagination={false} size="small" data-cy="top-anchors-table">
      <Column title="#" dataIndex="key" align="left" />
      <Column className="no-wrap" title="Anchor Text" dataIndex="anchor" />
      <Column
        className="no-wrap al-left"
        title="Domains"
        dataIndex="domains_num"
        render={(_, record) => parseInt(record["domains_num"]).toLocaleString()}
      />
      <Column
        className="no-wrap al-right"
        title="Backlinks"
        dataIndex="backlinks_num"
        render={(_, record) => parseInt(record["backlinks_num"]).toLocaleString()}
      />
      <Column
        className="no-wrap al-right"
        title="First Seen"
        dataIndex="first_seen"
        render={(_, record) => moment.unix(record["first_seen"]).format("MMM DD, YYYY")}
      />
      <Column
        className="no-wrap al-right"
        title="Last Seen"
        dataIndex="last_seen"
        render={(_, record) => moment.unix(record["last_seen"]).format("MMM DD, YYYY")}
      />
    </Table>
  );
};

export default TopAnchorsTable;
